<template>
  <v-row>
    <v-col cols="12">
      <!-- <v-textarea v-model="data.description" label="description"></v-textarea> -->
      <text-editor v-model="data.description"></text-editor>
    </v-col>
    <v-col cols="12">
      <v-text-field v-model="data.name" label="name"></v-text-field>
    </v-col>
    <v-col cols="12">
      <v-textarea rows="2" v-model="data.about" label="about"></v-textarea>
    </v-col>
    <v-col cols="12">
      <select-multi-categories
        v-model="data.categories"
      ></select-multi-categories>
    </v-col>
    <v-col class="d-flex" cols="12">
      <v-select
        :items="blogTypes"
        item-value="slug"
        item-text="name"
        v-model="data.blogTypeSlug"
        label="Select type of article for siloing purpose"
        dense
        outlined
        clearable
        return-object
      ></v-select>
    </v-col>
    <v-col cols="12">
      <v-file-input
        :loading="data.fileLoading"
        chips
        :clearable="false"
        v-model="data.file"
        label="image"
      ></v-file-input>
    </v-col>
    <v-col cols="12">
      <v-img
        class="rounded-br-lg elevation-5"
        v-if="data.image"
        :src="
          data.image && data.image.includes('storage')
            ? `${baseUrl}${data.image}`
            : `${baseUrl}/storage/${data.image}`
        "
        max-height="300"
        max-width="300"
        contain
      >
        <v-btn @click="deleteFile" width="100%" color="error"
          >Delete
          <v-icon color="white">
            mdi-close
          </v-icon>
        </v-btn>
        <v-progress-linear
          :active="deleteFileLoading"
          color="error"
          absolute
          bottom
          indeterminate
        ></v-progress-linear>
      </v-img>
    </v-col>
    <v-col cols="12">
      <v-switch v-model="data.active" label="active"></v-switch>
    </v-col>
  </v-row>
</template>

<script>
import { Strings, axios } from '../../../utils'
import TextEditor from '../../../components/TextEditor'
import SelectMultiCategories from '../../../components/SelectMultiCategories'
export default {
  name: 'BlogForm',
  props: ['data'],
  components: {
    TextEditor,
    SelectMultiCategories
  },
  created() {
    axios
      .get('/api/admin/blog-types')
      .then(response => {
        console.log(response.data)
        this.blogTypes = response.data
      })
      .catch(error => {
        console.log(error)
      })
  },
  data() {
    return {
      icons: ['mdi-rewind', '', 'mdi-fast-forward'],
      baseUrl: Strings.baseUrl,
      deleteFileLoading: false,
      blogTypes: []
    }
  },
  methods: {
    deleteFile() {
      this.deleteFileLoading = true

      if (this.data.id) {
        console.log('deleting blog media for id ', this.data.id)
        axios
          .delete(`api/admin/blogs/${this.data.id}/delete-media`)
          .then(res => {
            if (res.data === 1) {
              console.log('done')
              this.data.image = null
              this.deleteFileLoading = false
            }
          })
          .catch(err => console.log(err))
      } else {
        console.log('deleting media for path ', this.data.image)
        axios
          .get(`api/admin/file-delete?path=${this.data.image}`)
          .then(res => {
            if (res.data === 1) {
              console.log('done')
              this.data.image = null
              this.deleteFileLoading = false
            }
          })
          .catch(err => console.log(err))
      }
    }
  }
}
</script>

<style scoped></style>
